import axios from 'axios'
import { getEndpoint } from '../../../features/common/backend/endpoints'

export const getCreditsByMMV = async body => {
  const endpoint = getEndpoint('SIMULADOR_FINANCIERO')

  const fetchUrl = encodeURI(`${endpoint}/creditsByMMV`)
  const doRequest = await axios.post(fetchUrl, body)
  return doRequest.data.data
}
